import * as React from 'react'
import LeadIcon from '/static-assets/icons/global-search/search-results-icon-lead.svg'
import OpportunityIcon from '/static-assets/icons/global-search/search-results-icon-opportunity.svg'
import PendingLeadIcon from '/static-assets/icons/global-search/search-results-icon-pending-lead.svg'
import ClockIcon from '/static-assets/icons/global-search/time-clock.svg'

type Props = {
  entityType: string
}

export function EntityIcon(props: Props) {
  const { entityType } = props
  let svgSrc: string

  switch (entityType) {
    case 'DraftLead':
      svgSrc = PendingLeadIcon
      break
    case 'Lead':
      svgSrc = LeadIcon
      break
    case 'Opportunity':
      svgSrc = OpportunityIcon
      break
    case 'recent':
      svgSrc = ClockIcon
      break
    default:
      throw new Error(`Invalid entity type: ${entityType}`)
  }
  return <img src={svgSrc} alt={`${entityType} icon`} width={25} height={25} />
}
